import {
  PersonAdd as PersonAddIcon,
  LockReset as LockResetIcon,
  HandshakeOutlined as HandshakeOutlinedIcon,
} from '@mui/icons-material';
import styled, { css } from 'styled-components';
import { DrawerBase as Drawer } from '../../design-system';
import { i18n } from '../../i18n';
import { smallScreenSize } from '../../hooks';

export const NotificationsDrawerBase = styled(Drawer)`
  grid-template-rows: 6.8rem 1fr 6.8rem;
  grid-column: 3 / 4;
  grid-row: 1 / 3;

  background-color: var(--white);
  border-left: 0.1rem solid var(--gray-50);
  width: 40rem;
  height: 100%;
  overflow: hidden;
  transition: width 0.3s, border-left 0.3s, padding 0.3s;

  & > *:last-child {
    align-self: center;
    justify-self: center;
    width: max-content;
  }

  @media (max-width: ${smallScreenSize}px) {
    /* width: 100vw; */
  }

  ${(props) =>
    !props.isOpen &&
    css`
      width: 0;
      border-left: 0;

      @media (max-width: ${smallScreenSize}px) {
        width: 0;
      }
    `}
`;

export const notifications = {
  SIGN_UP: {
    icon: <PersonAddIcon />,
    title: i18n.t('pages.notifications.category.signUp'),
  },
  SIGN_UP_BUY_CONTAINER: {
    icon: <PersonAddIcon />,
    title: i18n.t('pages.notifications.category.signUpBuyContainer'),
  },
  FORGOT_PASSWORD: {
    icon: <LockResetIcon />,
    title: i18n.t('pages.notifications.category.forgotPassword'),
  },
  CLIENT_INTEREST_IN_YARD: {
    icon: <HandshakeOutlinedIcon />,
    title: i18n.t('pages.notifications.category.clientInterestInYard'),
  },
};
